import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { showNotification } from '../components/NotificationToast'

const firebaseConfig = process.env.REACT_APP_FIREBASE_CONFIG
const vapidKey = process.env.REACT_APP_FIREBASE_VAP_ID_KEY

const app = initializeApp(JSON.parse(firebaseConfig))
const messaging = getMessaging(app)

export const generateToken = async () => {
  const permission = await Notification.requestPermission()
  let token
  if (permission === 'granted') {
    token = await getToken(messaging, { vapidKey })
  }

  return token
}

export const startOnMessage = () => {
  onMessage(messaging, (payload) => {
    const { notification } = payload
    showNotification(notification)
  })
}